const Circle = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4.40625C16.1703 4.40625 19.5938 7.78389 19.5938 12C19.5938 16.1938 16.1973 19.5938 12 19.5938C7.80783 19.5938 4.40625 16.199 4.40625 12C4.40625 7.80927 7.80241 4.40625 12 4.40625ZM12 3.28125C7.18511 3.28125 3.28125 7.18651 3.28125 12C3.28125 16.8163 7.18511 20.7188 12 20.7188C16.8149 20.7188 20.7188 16.8163 20.7188 12C20.7188 7.18651 16.8149 3.28125 12 3.28125Z"
        fill="#646464"
      />
    </svg>
  )
}

export default Circle
